export default __webpack_public_path__ + "static/usherLooking-ef455057c3566ec5711125602e5f8ac2.svg";